import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import InstructorMontessoriMenu from "./InstructorMontessoriMenu";
import DynamicProfile from "./pages/is-kool-jr/DynamicProfile";
import FriendsPage from "./pages/is-kool-jr/FriendsPage";
import HelpPage from "./pages/HelpPage";
import Profile from "./pages/Profile";
import InstructorClassBroadcast from "./pages/is-kool-jr/message/InstructorClassBroadcast";
import SwitchMontessoriCard from "./pages/is-kool-jr/montessori-progress-card/SwitchMontessoriCard";
import MontessoriViewTemplate from "./pages/is-kool-jr/montessori-progress-card/MontessoriViewTemplate";
import MontessoriAddEditScore from "./pages/is-kool-jr/montessori-progress-card/MontessoriAddEditScore";
import MontessoriViewEditCard from "./pages/is-kool-jr/montessori-progress-card/MontessoriViewEditCard";
import MontessoriViewHistory from "./pages/is-kool-jr/montessori-progress-card/MontessoriViewHistory";
import Settings from "./pages/Settings/index";
import InstructorMessagePage from "./pages/is-kool-jr/message/index";
import SwitchClassAnnouncements from "./pages/is-kool-jr/message/SwitchClassAnnouncements";
import SwitchWhatsApp from "./pages/whatsapp/SwitchWhatsApp";
import TransportationStatus from "./pages/Transportation/TransportationStatus";
import SwitchTabs from "./pages/instructorAttendance/SwitchTabs";
import InstructorLiveTracking from "./pages/Live tracking";

import SwitchMontessoriAttendance from "./pages/is-kool-jr/attendance/SwitchMontessoriAttendance";
import SwitchDailyActivity from "./pages/is-kool-jr/daily-activity/SwitchDailyActivity";
import InstructorCourseBoardMain from "./pages/is-kool-jr/course-board/InstructorCourseBoardMain";
import InstructorCourseBoardView from "./pages/is-kool-jr/course-board/InstructorCourseBoardView";
import FunPage from "./pages/is-kool-jr/FunPage";
import SwitchExpense from "../admin/pages/components/manageexpenses/SwitchExpense";
import InstructorStock from "./pages/Stock/InstructorStock";
import SwitchTrip from "../admin/pages/components/managetrip/SwitchTrip";

const url = "/dashboard";

const InstructorMontessoriRoutes = () => {
  return (
    <Routes>
      <Route path="instructor/menu" element={<InstructorMontessoriMenu />} />
      <Route path="instructor/menu/profile" element={<Profile />} />
      <Route path="instructor/menu/friends" element={<FriendsPage />} />
      <Route path="instructor/menu/friends/:userId" element={<DynamicProfile />} />
      <Route path="instructor/help" element={<HelpPage />} />
      <Route path="instructor/menu/message/homework" element={<InstructorClassBroadcast />} />
      <Route path="instructor/menu/diary" element={<DiaryBoard role="instructor" mode="junior" />} />
      <Route path="instructor/menu/attendance" element={<SwitchMontessoriAttendance />} />
      <Route path="instructor/menu/daily-activity" element={<SwitchDailyActivity />} />
      <Route path="instructor/menu/course-board" element={<InstructorCourseBoardMain />} />
      <Route path="instructor/menu/course-board/class/:classId" element={<InstructorCourseBoardView />} />
      <Route path="instructor/menu/instructor-attendance" element={<SwitchTabs />} />
      <Route path="instructor/menu/setting/" element={<Settings />} />
      <Route path="instructor/home" element={<Profile />} />
      <Route path="instructor/menu/message/" element={<InstructorMessagePage />} />
      <Route path="instructor/menu/class-announcements/" element={<SwitchClassAnnouncements />} />
      <Route path="instructor/menu/whatsapp" element={<SwitchWhatsApp />} />
      <Route path="instructor/menu/whatsapp/:tab" element={<SwitchWhatsApp />} />
      <Route path="instructor/menu/transportation/" element={<TransportationStatus />} />
      <Route path="instructor/menu/live-tracking/" element={<InstructorLiveTracking />} />
      <Route path="instructor/menu/fun/" element={<FunPage />} />
      <Route path="instructor/menu/montessori-report/" element={<SwitchMontessoriCard />} />
      <Route path="instructor/menu/montessori-report/template/:id" element={<MontessoriViewTemplate />} />
      <Route path="instructor/menu/montessori-student/:id/template/:id" element={<MontessoriAddEditScore />} />
      <Route path="instructor/menu/montessori-student/:id/template/:id/report/:id/" element={<MontessoriViewEditCard />} />
      <Route path="instructor/menu/montessori-template-history/:id" element={<MontessoriViewHistory />} />
      <Route path="instructor/menu/expenses" element={<SwitchExpense />} />
      <Route path="instructor/menu/stock" element={<InstructorStock />} />
      <Route path="instructor/menu/consent-form/:tab" element={<SwitchTrip basePath="/dashboard/instructor/menu/consent-form" />} />
      <Route index element={<Navigate to={`${url}/instructor/home`} replace />} />
    </Routes>
  );
};

export default InstructorMontessoriRoutes;
